import AuthContext from 'contexts/AWSCognitoContext';
import { useContext } from 'react';

/** `useSettings`' readers over a session's `enabledSettings`, for code that is handed the list. */
export const settingReaders = (enabledSettings: string[] | null | undefined) => ({
    isSettingEnabled: (key: string) => !!enabledSettings?.includes(key),
    isOptionEnabled: (key: string, option: string) => !!enabledSettings?.includes(`${key}:${option}`),
});

/**
 * Whether a back-office setting, or one of its sub-options, is on for the signed-in colleague. The session carries
 * the answer as `enabledSettings`, with the whole rule already applied by the backend: a setting inside a paid module
 * is off while that module is off, one for selected colleagues is on only for them, and a sub-option (`KEY:option`)
 * is on only while its setting is. Reads the auth context directly, as `useLastNameFirst` does, rather than `useAuth`,
 * which throws without a provider: `PartyName` and the pickers read settings and render in tests that have none.
 */
export const useSettings = () => settingReaders(useContext(AuthContext)?.user?.enabledSettings);
